module.exports = __webpack_public_path__ + "static/media/completed.b96a897f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/completed.png
// module id = 145
// module chunks = 0